import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { contentHeaders, apiBaseUrl } from "../common/config/config";
import { ActionSheetController, Platform, LoadingController, ToastController } from "@ionic/angular";
let apiUrl = apiBaseUrl + "payments/";
@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  public reportId:any;
  public txnId:any;
  public headers :any;
  public amount:any;
  public nextpage = "/home";
  public txnSt = "no";
  public regNumber:any;
  constructor(public http: HttpClient) {
    this.headers = contentHeaders;
  }
  getById() {
    return new Promise((resolve, reject) => {
      this.http.get(apiUrl + this.txnId , { headers: this.headers }).subscribe((res) => {
        resolve(res['data']);
      },(err) => {
        reject(err);
      });
    });
  }
  async payWithVPA(handle){
    return new Promise(async(resolve, reject) => {
      // await this.headers.set("app-key", "nMQpUdhs9HtfcxLT");
      this.http.post(apiUrl + this.txnId +'/byVPA', {vpa:handle}, { headers: {"app-key":"nMQpUdhs9HtfcxLT",'Content-Type':'application/json'} }).subscribe((res) => {
        resolve(res['data']);
      },(err) => {
        reject(err);
      });
    });
  }
  async payWithUPI(){
    return new Promise(async(resolve, reject) => {
      // await this.headers.set("app-key", "nMQpUdhs9HtfcxLT");
      this.http.get(apiUrl + this.txnId +'/byUPI', { headers: {"app-key":"IcPH01ycgxAaKtQw",'Content-Type':'application/json'} }).subscribe((res) => {
        resolve(res['data']);
      },(err) => {
        reject(err);
      });
    });
  }

}
